define.alias("shared/components/shared/pre-boarding/auto-trial-start/index", "settings/components/shared/pre-boarding/auto-trial-start/index");